import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useCallback, useMemo, useState } from 'react';

import { Item, OptionBinding as OptionBindingT } from 'apis/restaurant-api/merchant-admin/menu2/types';

import OptionBinding from '../OptionBinding';

type Props = {
  item: Item;
  optionBinding: OptionBindingT;
};

const OptionBindingListItem = ({ item, optionBinding }: Props) => {
  const [open, setOpen] = useState(false);

  const handleToggleOpen = useCallback(() => {
    setOpen(value => !value);
  }, []);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: optionBinding.id,
  });

  const style = useMemo(
    () => ({
      transform: CSS.Transform.toString(transform),
      transition,
    }),
    [transform, transition],
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <OptionBinding
        disableHoverStyle={isDragging}
        dragging={isDragging}
        item={item}
        onToggleOpen={handleToggleOpen}
        open={open}
        optionBinding={optionBinding}
      />
    </div>
  );
};

export default OptionBindingListItem;
